var viewer_rtlignore_default = {
  "gallery_container": "tK63K",
  "imageTitleContainer": "ZegoF",
  "clickableItem": "qa6SC",
  "prerender": "U6vAg",
  "expandContainer": "XbJgF",
  "expandIcon": "sJdv3",
  "itemOverlay": "mt2eh",
  "imageTitle": "ioHU2",
  "pointer": "itXvY",
  "fadeIn": "Rut-7",
  "changing_background": "syODt"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
